import type { IconNode } from '../types';

/**
 * @name bottle-plastic
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNi4xVjNjMC0uNi40LTEgMS0xaDJjLjYgMCAxIC40IDEgMXYzLjEiIC8+CiAgPHBhdGggZD0iTTE3IDE0LjVjMC0xLjItLjktMi4yLTItMi40VjEyYTIgMiAwIDAgMCAyLTIgNCA0IDAgMCAwLTQtNGgtMmE0IDQgMCAwIDAtNCA0IDIgMiAwIDAgMCAyIDJ2LjFhMi41IDIuNSAwIDAgMCAwIDQuOHYuMWEyIDIgMCAwIDAtMiAydjFhMiAyIDAgMCAwIDIgMmg2YTIgMiAwIDAgMCAyLTJ2LTFhMiAyIDAgMCAwLTItMnYtLjFjMS4xLS4yIDItMS4yIDItMi40IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bottle-plastic
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottlePlastic: IconNode = [
  ['path', { d: 'M10 6.1V3c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v3.1', key: 'pl1sbb' }],
  [
    'path',
    {
      d: 'M17 14.5c0-1.2-.9-2.2-2-2.4V12a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-2a4 4 0 0 0-4 4 2 2 0 0 0 2 2v.1a2.5 2.5 0 0 0 0 4.8v.1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2v-.1c1.1-.2 2-1.2 2-2.4',
      key: 'ymgkr4',
    },
  ],
];

export default bottlePlastic;
